/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { messagesCountsOverTimeGetApiV3MessagesCountsOverTime } from "../../funcs/messagesCountsOverTimeGetApiV3MessagesCountsOverTime.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3MessagesCountsOverTimeRequest$inboundSchema,
};

export const tool$messagesCountsOverTimeGetApiV3MessagesCountsOverTime:
  ToolDefinition<typeof args> = {
    name: "messages-counts-over-time-get-api-v3-messages-counts-over-time",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await messagesCountsOverTimeGetApiV3MessagesCountsOverTime(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
